// <www.sharporator.com[readonly.file]> do not change the file or delete this line

import React from 'react'
import WebFaSolutionTestComponentPresenter from './webFaSolutionTestComponentPresenter'
import Loading from '../../components-lib/loading'
import ErrorMessage from '../../components-lib/errorMessage'
import Success from '../../components-lib/success'
import {useAxios} from '../../hooks/useAxios'
    export default
    // Caption: Получить токен от ФА
        function WebFaSolutionTestComponent(
        props
        )
        {
            const [{response: bankProxyServerConnectionParams, isLoading: bankProxyServerConnectionParamsLoading, error: bankProxyServerConnectionParamsError}, bankProxyServerConnectionParamsFetch, bankProxyServerConnectionParamsClear] = useAxios()
            const bankProxyServerConnectionParamsPost = 
                (phoneDto, responseCallback, errorCallback, cancelCallback) => {
                    bankProxyServerConnectionParamsFetch({
                        url: `/WebFaSolution/GetTokenAndIp`,
                        data: phoneDto,
                        method: "post",
                        responseCallback,
                        errorCallback,
                        cancelCallback
                    });
                }
            function webFaSolutionTestComponentPresenterRender() {
                return (
                    <>
                        {bankProxyServerConnectionParamsLoading && <Loading isSaving/>}
                        {bankProxyServerConnectionParamsError && <ErrorMessage error={bankProxyServerConnectionParamsError} fetchForInit={bankProxyServerConnectionParamsClear}/>}
                        {bankProxyServerConnectionParams && <Success/>}
                        <WebFaSolutionTestComponentPresenter
                            bankProxyServerConnectionParams={bankProxyServerConnectionParams}
                            onBankProxyServerConnectionParamsPost={bankProxyServerConnectionParamsPost}
                            onBankProxyServerConnectionParamsClear={bankProxyServerConnectionParamsClear}
                            {...props}
                        />
                    </>
                )
            }
            return (
                webFaSolutionTestComponentPresenterRender()
            )
        }
